import {Euler, Vector3, Scene} from "three";

const FLOOR_NUMBER = {
    BOTTOM_FLOOR: 1,
    TOP_FLOOR: 2,
};
// Here we split by Artists Names
//ChatRoom01
//ScreenStageLeft
const CameraLocationsDB = [
    {
        cameraLocationId: 'GroundFloorCamLoc',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Ground Floor`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationLevel2Id: ['WEL_CAMERA01', 'INF_CAMERA01', 'HSC_CAMERA01', 'RO1_CAMERA01', 'RO2_CAMERA01'],
    },
    {
        cameraLocationId: 'WEL_CAMERA01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Welcome to Silk Along<br>the Silk Road`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'INF_CAMERA01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Information Desk`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'HSC_CAMERA01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `How to Make Silk`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'RO1_CAMERA01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Robes 500 - 1000`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'RO2_CAMERA01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Robes 1000 - 1500`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },

    {
        cameraLocationId: 'FirstFloorCamLoc',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `First Floor`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationLevel2Id: ['MO1_CAMERA01', 'MO2_CAMERA01'],
    },
    {
        cameraLocationId: 'MO1_CAMERA01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Motifs (500 - 1000 CE)`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },
    {
        cameraLocationId: 'MO2_CAMERA01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Motifs (1000 - 1500 CE)`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
    },

    {
        cameraLocationId: 'DownStairsLoc',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Down Stairs`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        hideFromModal: 'Y',
    },
    {
        cameraLocationId: 'UpStairsLoc',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Up Stairs`,
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
        cameraLocationIdOfChild: 'Y',
        hideFromModal: 'Y',
    }

];

export {CameraLocationsDB, FLOOR_NUMBER};
